/** Форматирует чистое число ("1500000" или "1500000.5") в вид с пробелами-разрядами. */
export function formatMoney(raw: string): string {
  if (!raw) return ''
  const [intPart, decPart] = raw.split('.')
  const withSpaces = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
  return decPart !== undefined ? `${withSpaces}.${decPart}` : withSpaces
}

/** Разбирает пользовательский ввод (с пробелами/запятой) в чистое число-строку. */
export function parseMoneyInput(display: string): string {
  const cleaned = display.replace(/[^\d.,]/g, '').replace(',', '.')
  const firstDot = cleaned.indexOf('.')
  if (firstDot === -1) return cleaned
  return cleaned.slice(0, firstDot + 1) + cleaned.slice(firstDot + 1).replace(/\./g, '')
}
